import { template } from '../../template';

app.BadgeDetailsView = app.BaseDetailsView.extend({
  template: template($('#menu-item-array-details-template').html()),

  initialize() {
    app.BaseDetailsView.prototype.initialize.apply(this, arguments);

    const badge = this.model;
    if (badge.isSynced && badge.isSynced()) {
      this.options.warningText =
        'This badge is managed by a POS integration. Updates must be made on the POS and re-synced.';
    }
    if (!badge.isNew()) {
      const menuItems = app.menuItemList.filter((menuItem) => {
        return menuItem.get('badges')?.some(({ _id: badgeId }) => badgeId === badge.id);
      });
      this._menuItemList = new app.MenuItemList(menuItems);
      this.listenTo(this._menuItemList, 'add', this._renderItemLists);
      this.listenTo(this._menuItemList, 'change', this._renderItemLists);
      this.listenTo(this._menuItemList, 'remove', this._renderItemLists);

      const mods = app.modList.filter((mod) => {
        return mod.get('badges')?.some(({ _id: badgeId }) => badgeId === badge.id);
      });
      this._modList = new app.ModList(mods);
      this.listenTo(this._modList, 'add', this._renderItemLists);
      this.listenTo(this._modList, 'change', this._renderItemLists);
      this.listenTo(this._modList, 'remove', this._renderItemLists);
    }
  },

  _renderItemLists() {
    this._renderMenuItemList();
    this._renderModList();
  },

  _renderMenuItemList() {
    const menuItemIds = this._menuItemList.map((item) => item.id);

    if (this._menuItemDropdown) {
      this._menuItemDropdown.destroy();
    }
    this._menuItemDropdown = new app.Dropdown();
    const $itemPanel = this.$('.menu-item-list.item-list-panel');
    this._menuItemDropdown.setupRows($itemPanel, menuItemIds, this._menuItemList, {
      onClick(item) {
        const detailsView = new app.MenuItemDetailsView({
          model: item,
        });
        app.modalManager.showModalWithView(detailsView);
      },
      canBeRemoved() {
        return false;
      },
    });

    this.$el.find('.menu-item-list .card-footer').show();
    let summary = '';
    if (menuItemIds.length) {
      summary += `${menuItemIds.length} menu item${menuItemIds.length === 1 ? '' : 's'}`;
    } else {
      summary += 'No menu items are using this badge yet.';
    }
    this.$el.find('.menu-item-list .card-footer').html(summary);
  },

  _renderModList() {
    const modIds = this._modList.map((mod) => mod.id);

    if (this._modDropdown) {
      this._modDropdown.destroy();
    }
    this._modDropdown = new app.Dropdown();
    const $itemPanel = this.$('.mod-list.item-list-panel');
    this._modDropdown.setupRows($itemPanel, modIds, this._modList, {
      onClick(mod) {
        const detailsView = new app.MenuItemDetailsView({
          model: mod,
        });
        app.modalManager.showModalWithView(detailsView);
      },
      canBeRemoved() {
        return false;
      },
    });

    this.$el.find('.mod-list .card-footer').show();
    let summary = '';
    if (modIds.length) {
      summary += `${modIds.length} modifier${modIds.length === 1 ? '' : 's'}`;
    } else {
      summary += 'No modifiers are using this badge yet.';
    }
    this.$el.find('.mod-list .card-footer').html(summary);
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    if (this._menuItemList && this._modList) {
      this.$el.append(
        $(
          this.template({
            canAddItems: false,
            canCreateItems: false,
            itemCategory: 'Menu Item',
          }),
        ).addClass('menu-item-list'),
      );
      this.$el.append(
        $(
          this.template({
            canAddItems: false,
            canCreateItems: false,
            itemCategory: 'Modifier',
          }),
        ).addClass('mod-list'),
      );

      this._renderItemLists();
    }

    return this;
  },
});
